// MoonCase landing page — real customer reviews for the "Toate review-urile" modal.
// Every entry below is a real name + real text from the store's customer list.
// No ratings or text here are generated or substituted — every card shows exactly
// what's in this file, and every card is shown (nothing is filtered out at random).
(function(){
  var photoReviews = [
    {url:(window.moonReviewPhotos && window.moonReviewPhotos.baiat1), name:"Mihai R.", text:"Auriu arata bestial in realitate, top!"},
    {url:(window.moonReviewPhotos && window.moonReviewPhotos.baiat2), name:"Andrei T.", text:"Exact ca in poze, super calitate."},
    {url:(window.moonReviewPhotos && window.moonReviewPhotos.fata1), name:"Ioana C.", text:"E superba, toata lumea m-a intrebat de ea!"},
    {url:(window.moonReviewPhotos && window.moonReviewPhotos.fata2), name:"Alexandra D.", text:"Ocean Blue e visul meu, il pun peste tot!"},
    {url:(window.moonReviewPhotos && window.moonReviewPhotos.fata3), name:"Maria G.", text:"Silver e fix cum ma asteptam, o ador!"}
  ];

  var textReviews = [
["Andrei","fratie e sic, toata lumea m-a intrebat de ea in prima zi"],
["Matei","ma asteptam sa fie mai fragila sincer, dar e solida. black arata bestial"],
["Alexandru","de cand am pus-o nu am mai dat jos. arata altfel decat orice husa am mai vazut"],
["David","merita fiecare leu, a venit repede si arata exact ca in poze"],
["Gabriel","cea mai tare husa pe care am avut-o, nu se compara cu nimic de pe piata"],
["Andreea","Foarte multumita, arata super clean."],
["Alex","Husa e subtire, usoara si telefonul arata in continuare premium."],
["Bianca","Exact ce cautam."],
["David","Nu imi plac husele groase, iar asta e perfecta pentru mine."],
["Maria","Arata foarte elegant pe telefon."],
["Denis","Se lipeste bine si se simte calitativa."],
["Mihai","Recomand, chiar merita."],
["Elena","Imi place ca nu acopera designul telefonului."],
["Raul","Simplu, premium, fara sa faca telefonul mare."],
["Daria","Superba."],
["Cristina","Sunt foarte multumita de alegere."],
["Stefan","Initial nu stiam daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut top."],
["Larisa","Finuta si eleganta."],
["Vlad","Arata diferit fata de tot ce am avut pana acum."],
["Ana","Am luat varianta neagra si chiar arata genial."],
["Paul","Produsul e fix ca in poze."],
["Roxana","Imi place mult ca spatele telefonului ramane vizibil."],
["George","Montaj usor, aspect premium."],
["Alina","O husa minimalista, dar de efect."],
["Robert","Nu ma asteptam sa fie asa placuta in mana."],
["Simona","O folosesc zilnic si sunt foarte multumita de ea."],
["Catalin","Telefonul ramane subtire."],
["Teodora","Mi-a placut si ambalajul, se simte ca un produs premium."],
["Ionut","Foarte buna alternativa la husele clasice."],
["Alexandra","Se aseaza perfect si culoarea arata foarte bine."],
["Sebi","Calitate buna, livrare rapida."],
["Patricia","Telefonul arata superb cu ea, chiar recomand."],
["Rares","Fix stilul meu."],
["Diana","E simpla, dar schimba total vibe-ul telefonului."],
["Marian","Pentru cine vrea ceva discret si premium, e ce trebuie."],
["Amalia","Nu aluneca si se simte bine in mana."],
["Cosmin","Totul a fost in regula."],
["Oana","Arata foarte elegant, mai ales daca iti place telefonul fara husa clasica."],
["Eduard","Se vede ca e lucrata bine."],
["Gabriela","Sunt incantata, sincer chiar merita."],
["Luca","Dupa asta nu prea imi mai vine sa folosesc huse normale."],
["Adelina","Telefonul ramane aproape la fel de subtire."],
["Florin","Foarte misto pentru stil minimalist."],
["Rebeca","Am primit multe intrebari despre ea."],
["Matei","Calitate peste asteptari, sunt multumit."],
["Claudia","Finuta, usoara si se potriveste perfect."],
["Victor","Nu strica deloc designul telefonului."],
["Sonia","Draguta si eleganta."],
["Razvan","Am comandat din curiozitate si chiar m-a surprins placut."],
["Miruna","Imi place mult cum se vede pe telefon."],
["Bogdan","Protejeaza fix cat trebuie si arata foarte bine."],
["Georgiana","Recomand cu drag."],
["Adrian","Mi se pare una dintre cele mai clean variante pentru iPhone."],
["Edi","Am luat-o din curiozitate si sincer m-a surprins placut."],
["George","Arata simplu, dar se vede ca are un vibe mai premium."],
["Raluca","Se simte bine in mana si nu pare deloc ieftina."],
["Larisa","E o alternativa foarte buna la husele clasice."],
["Sorin","Am luat-o pentru ca a fost exact ce cautam."],
["Stefania","Imi place mult ideea, e diferita fata de husele normale."],
["Catalin","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Marius","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Oana","Se monteaza usor si schimba complet aspectul telefonului."],
["Diana Maria","Dupa cateva zile de folosire, a fost exact ce cautam."],
["Beatrice","Nu ma asteptam, dar pare mult mai scumpa decat ma asteptam."],
["Sebastian","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Ilinca","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Diana Maria","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Ayan","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp."],
["Delia","Sincer nu eram sigur daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut mult mai faina decat o husa normala."],
["Gabriela","Perfecta pentru iPhone. Recomand."],
["Maria","Foarte ok la prima impresie."],
["Carla","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp."],
["Mihai","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Luca","Cel mai mult imi place ca imi lasa telefonul sa arate ca telefon, nu ca o caramida."],
["Mihai","Perfecta pentru iPhone."],
["Lucian","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon. Chiar sunt multumit."],
["Nicolas","Culoarea arata bine si se potriveste perfect pe telefon."],
["Camelia","Se potriveste foarte bine si nu misca deloc."],
["Adina","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Sebi","Am primit comanda repede si produsul arata foarte bine."],
["Darius","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Monica","Se simte calitativa."],
["Stefania","Am fost putin sceptic la inceput, dar produsul chiar arata bine live. Telefonul pare mai elegant si mai special."],
["Ariana","Imi place ca telefonul ramane subtire si arata in continuare premium. Arata foarte bine pe negru."],
["Diana Maria","Foarte faina husa."],
["Raul","Se simte calitativa."],
["Aris","La inceput mi s-a parut ciudata ideea, dar dupa ce am vazut-o pe telefon am inteles de ce arata asa bine. Sunt multumit. Recomand."],
["Paula","Se simte calitativa."],
["Marius","Nu ma asteptam sa fie asa placuta in mana."],
["Mario","Am primit multe intrebari despre ea, arata chiar interesant."],
["Iulia","Am comandat-o pentru ca voiam ceva diferit, nu o husa mare si greoaie. Arata foarte bine si telefonul ramane clean."],
["David","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Adrian","Se potriveste foarte bine si nu misca deloc."],
["Nicolas","Am comandat-o pentru ca voiam ceva diferit, nu o husa mare si greoaie. Arata foarte bine si telefonul ramane clean."],
["Alex","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Lavinia","Sunt foarte incantat. Mi-a placut mult."],
["Larisa","La inceput mi s-a parut ciudata ideea, dar dupa ce am vazut-o pe telefon am inteles de ce arata asa bine. Sunt multumit."],
["Oana","Se monteaza usor si schimba complet aspectul telefonului."],
["Amalia","Am comandat-o ieri si nu aluneca usor din mana. Chiar sunt multumit."],
["Matei","Se potriveste foarte bine si nu misca deloc."],
["Ionut","E fix genul de husa discreta pe care o cautam de mult."],
["Mihaela","Mi se pare foarte potrivita pentru cine vrea protectie discreta si un look mai premium. Eu sunt multumit de alegere."],
["Matei","Sunt foarte incantat."],
["Eric","Am fost putin sceptic la inceput, dar produsul chiar arata bine live. Telefonul pare mai elegant si mai special. Recomand."],
["Stefan","Telefonul ramane aproape la fel de subtire, asta imi place cel mai mult."],
["Ana","E fix genul de husa discreta pe care o cautam de mult."],
["Ciprian","Super clean pe telefon."],
["Patrick","Clean si usoara."],
["Ema","Am fost putin sceptic la inceput, dar produsul chiar arata bine live. Telefonul pare mai elegant si mai special."],
["Denis","Am luat-o din curiozitate si sincer m-a surprins placut."],
["Ilinca","Pe telefon arata mi se pare foarte clean."],
["Cristian","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Adelina","Nu ma asteptam sa fie asa placuta in mana."],
["Monica","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna."],
["Sorina","Simpla si eleganta. Arata foarte bine pe negru."],
["Ema","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Laurentiu","Am primit comanda repede si produsul arata foarte bine."],
["Antonio","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Raul","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Mihaela","Pe telefon arata imi lasa telefonul sa arate ca telefon, nu ca o caramida."],
["Octavian","Nu ma asteptam sa fie asa placuta in mana. Recomand."],
["Flavius","Super clean pe telefon. Chiar sunt multumit."],
["Daria","Se aseaza foarte bine."],
["Cosmin","Se simte calitativa."],
["Sebi","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."],
["Albert","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Vlad","Nu ma asteptam sa fie asa placuta in mana."],
["Bogdan","Culoarea arata bine si se potriveste perfect pe telefon."],
["Edi","Prima impresie: se vede ca e gandita pentru look minimalist."],
["Tudor","Se monteaza usor si schimba complet aspectul telefonului."],
["Iulia","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Raluca","Mi se pare foarte potrivita pentru cine vrea protectie discreta si un look mai premium. Eu sunt multumit de alegere."],
["Valentina","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Cosmin","Foarte ok la prima impresie."],
["Adrian","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Matei","Se simte calitativa."],
["Mihai","Am primit multe intrebari despre ea, arata chiar interesant."],
["Tudor","Culoarea arata bine si se potriveste perfect pe telefon. Recomand."],
["Alexia","Se monteaza usor si schimba complet aspectul telefonului. Mi-a placut mult."],
["Flavius","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Claudiu","Telefonul ramane aproape la fel de subtire, asta imi place cel mai mult."],
["Cezara","Livrare rapida, produs bun."],
["Elena","Nu ma asteptam sa fie asa placuta in mana."],
["Cosmin","Dupa cateva zile de folosire, e simpla, dar de efect."],
["Victor","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant. Chiar sunt multumit."],
["Tavi","Nu ingroasa telefonul. Arata foarte bine pe negru."],
["Eric","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Amalia","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Claudia","Imi place ca telefonul ramane subtire si arata in continuare premium."],
["Tudor","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Albert","Culoarea arata bine si se potriveste perfect pe telefon."],
["Catalin","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."],
["Nicolas","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Tudor","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Andreea","Am comandat-o pentru ca voiam ceva diferit, nu o husa mare si greoaie. Arata foarte bine si telefonul ramane clean. Recomand."],
["Claudia","Simpla si eleganta."],
["Iustin","Nu ma asteptam, dar mi se pare foarte clean."],
["Irina","Culoarea arata bine si se potriveste perfect pe telefon."],
["Andreea","Se potriveste foarte bine si nu misca deloc."],
["Ianis","Sincer nu eram sigur daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut mult mai faina decat o husa normala."],
["Carmen","Minimalista si frumoasa."],
["Silviu","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Bianca","Nu ma asteptam sa fie asa placuta in mana."],
["Cosmin","Am luat-o pentru ca se potriveste cu stilul meu."],
["Sorina","Am comandat-o pentru ca voiam ceva diferit, nu o husa mare si greoaie. Arata foarte bine si telefonul ramane clean."],
["Alex","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Mihaela","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Stefan","Foarte faina husa. Chiar sunt multumit."],
["Lucian","Nu ma asteptam, dar a fost exact ce cautam."],
["Alexandru","Am folosit-o cateva zile si sunt foarte multumit de alegere."],
["Mario","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Simona","Super clean pe telefon. Recomand."],
["Claudiu","Cel mai mult imi place ca mi se pare foarte clean."],
["Denisa","Dupa cateva zile de folosire pot spune ca sunt multumit. Sta bine, arata bine si se simte placut in mana."],
["Sorin","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Paul","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna."],
["Octavian","Produs bun, ambalaj ok si livrarea a fost rapida. Arata foarte bine pe negru."],
["Sorina","Se potriveste foarte bine si nu misca deloc."],
["Claudiu","Nu ingroasa telefonul."],
["Marian","Am folosit-o cateva zile si sunt foarte multumit de alegere."],
["Raul","Am primit multe intrebari despre ea, arata chiar interesant."],
["Larisa","Pentru mine, e simpla, dar de efect. Mi-a placut mult."],
["Valentin","Imi place ca telefonul ramane subtire si arata in continuare premium."],
["Camelia","Am comandat-o ieri si imi lasa telefonul sa arate ca telefon, nu ca o caramida."],
["Antonio","Exact ce voiam."],
["Marius","Cel mai mult imi place ca nu aluneca usor din mana."],
["Antonio","Am luat-o din curiozitate si sincer m-a surprins placut."],
["Silviu","Mi-a placut si ambalajul, iar husa se simte calitativa. Nu pare un produs luat la intamplare, chiar arata premium."],
["Irina","Imi place mult ideea, e diferita fata de husele normale. Recomand."],
["Valentina","Am comandat pentru iPhone si se potriveste perfect. Imi place ca ramane vizibil spatele telefonului si nu il acopera aiurea."],
["Simona","Nu suport husele groase, iar asta mi se pare varianta perfecta. Chiar sunt multumit."],
["Eduard","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Claudiu","Foarte faina husa."],
["Iustin","Exact ce voiam."],
["Iustin","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna."],
["Camelia","Dupa cateva zile de folosire, arata foarte bine in poze si live."],
["Claudiu","Foarte ok la prima impresie."],
["Anca","Nu ma asteptam sa fie asa placuta in mana."],
["Patrick","Prima impresie: nu face telefonul gros."],
["Cosmin","Dupa cateva zile de folosire, arata foarte bine in poze si live."],
["Cosmin","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."],
["Paula","Se potriveste foarte bine si nu misca deloc."],
["Ionut","Se monteaza usor si schimba complet aspectul telefonului."],
["Ciprian","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Lavinia","Am primit comanda repede si produsul arata foarte bine."],
["Roxana","Arata premium. Recomand."],
["Antonio","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna."],
["Rebeca","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat. Arata foarte bine pe negru."],
["Denisa","Nu ingroasa telefonul."],
["Vasile","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Laurentiu","Dupa cateva zile de folosire pot spune ca sunt multumit. Sta bine, arata bine si se simte placut in mana."],
["Lavinia","Culoarea arata bine si se potriveste perfect pe telefon."],
["Paula","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Delia","Am comandat-o ieri si nu aluneca usor din mana. Chiar sunt multumit."],
["Roxana","Imi place mult."],
["Carla","Am primit comanda repede si produsul arata foarte bine."],
["Ionut","Perfecta pentru iPhone."],
["Valentin","Arata mai bine live."],
["Antonio","Telefonul ramane aproape la fel de subtire, asta imi place cel mai mult."],
["Alexia","Foarte ok la prima impresie."],
["Vasile","Simpla si eleganta."],
["Rares","Sunt foarte incantat."],
["Sonia","Sincer nu eram sigur daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut mult mai faina decat o husa normala. Recomand."],
["Ayan","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Denis","Daca vrei ceva minimalist, chiar e ce trebuie. Mi-a placut mult."],
["Patrick","Am folosit-o cateva zile si sunt foarte multumit de alegere."],
["Matei","Sincer nu eram sigur daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut mult mai faina decat o husa normala."],
["Isabela","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Oana","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Cezara","Se monteaza usor si schimba complet aspectul telefonului."],
["George","Am luat-o pentru ca se potriveste cu stilul meu."],
["Diana","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Razvan","Am primit comanda repede si produsul arata foarte bine."],
["Rebeca","Am folosit-o cateva zile si sunt foarte multumit de alegere."],
["Claudia","Se potriveste foarte bine si nu misca deloc."],
["Sorina","Cel mai mult imi place ca nu aluneca usor din mana."],
["Valentin","Nu ma asteptam sa fie asa placuta in mana. Chiar sunt multumit."],
["Nicu","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Larisa","Daca vrei ceva minimalist, chiar e ce trebuie. Arata foarte bine pe negru."],
["Nicoleta","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata. Recomand."],
["Patricia","Perfecta pentru iPhone."],
["Albert","Am comandat-o pentru ca voiam ceva diferit, nu o husa mare si greoaie. Arata foarte bine si telefonul ramane clean."],
["Rares","Am luat-o pentru ca se vede ca e gandita pentru look minimalist."],
["Gabriela","Se simte bine in mana si nu pare deloc ieftina."],
["Monica","Mi-a placut si ambalajul, iar husa se simte calitativa. Nu pare un produs luat la intamplare, chiar arata premium."],
["Dani","Culoarea arata bine si se potriveste perfect pe telefon."],
["Ionut","Am fost putin sceptic la inceput, dar produsul chiar arata bine live. Telefonul pare mai elegant si mai special."],
["Adrian","Am primit comanda repede si produsul arata foarte bine."],
["Maria","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["David","Recomand, chiar e misto."],
["Flavius","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Maria","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Amalia","Am comandat pentru iPhone si se potriveste perfect. Imi place ca ramane vizibil spatele telefonului si nu il acopera aiurea."],
["Calin","Merita banii."],
["Loredana","Se simte calitativa."],
["Claudiu","Se monteaza usor si schimba complet aspectul telefonului."],
["Alexandru","Imi place mult ideea, e diferita fata de husele normale. Recomand."],
["Beatrice","Prima impresie: a fost exact ce cautam."],
["Oana","Am comandat pentru iPhone si se potriveste perfect. Imi place ca ramane vizibil spatele telefonului si nu il acopera aiurea."],
["Iustin","Minimalista si frumoasa. Chiar sunt multumit."],
["Stefania","Foarte faina husa."],
["Adelina","E o alternativa foarte buna la husele clasice."],
["Ionut","Perfecta pentru iPhone."],
["Claudia","Arata simplu, dar se vede ca are un vibe mai premium."],
["Daria","Am primit multe intrebari despre ea, arata chiar interesant."],
["Diana Maria","Se simte calitativa."],
["Ariana","Pe telefon arata mi se pare foarte clean."],
["Isabela","Arata simplu, dar se vede ca are un vibe mai premium. Mi-a placut mult."],
["Bogdan","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Valentin","Prima impresie: se potriveste cu stilul meu. Arata foarte bine pe negru."],
["Claudiu","Imi place ca telefonul ramane subtire si arata in continuare premium."],
["Gabriel","Se simte calitativa."],
["Carla","Am comandat pentru iPhone si se potriveste perfect. Imi place ca ramane vizibil spatele telefonului si nu il acopera aiurea."],
["Laurentiu","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata. Recomand."],
["Rares","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Miruna","Se potriveste foarte bine si nu misca deloc."],
["Ioana","Se potriveste foarte bine si nu misca deloc."],
["Alexandra","E fix genul de husa discreta pe care o cautam de mult."],
["Paula","Telefonul ramane aproape la fel de subtire, asta imi place cel mai mult."],
["Oana","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Mihnea","Arata simplu, dar se vede ca are un vibe mai premium."],
["Iustin","Imi place mult ideea, e diferita fata de husele normale."],
["Gabriel","Se monteaza usor si schimba complet aspectul telefonului. Chiar sunt multumit."],
["Carla","Arata simplu, dar se vede ca are un vibe mai premium."],
["Eduard","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna."],
["Paul","Nu ingroasa telefonul."],
["Fabian","Se monteaza usor si schimba complet aspectul telefonului."],
["Adelina","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Giulia","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Sabina","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp."],
["Ilinca","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp. Recomand."],
["Paul","Recomand, chiar e misto."],
["Adelina","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Mihaela","Prima impresie: e simpla, dar de efect."],
["Eduard","Dupa cateva zile de folosire, a fost exact ce cautam."],
["George","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Nicu","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Oana","Am luat-o din curiozitate si sincer m-a surprins placut."],
["Patrick","Arata simplu, dar se vede ca are un vibe mai premium."],
["Ema","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Irina","Am luat-o din curiozitate si sincer m-a surprins placut. Arata foarte bine pe negru."],
["Sorina","E o alternativa foarte buna la husele clasice."],
["Paula","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Dragos","Sincer nu eram sigur daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut mult mai faina decat o husa normala."],
["Edi","Perfecta pentru iPhone."],
["Nicoleta","Nu ma asteptam sa fie asa placuta in mana. Chiar sunt multumit."],
["Vasile","Se potriveste foarte bine si nu misca deloc."],
["Sonia","Ca aspect, nu face telefonul gros. Recomand."],
["Gabriel","Am comandat-o ieri si pare mult mai scumpa decat ma asteptam."],
["Delia","Sincer, arata foarte bine in poze si live."],
["Cristina","Minimalista si frumoasa. Mi-a placut mult."],
["Raul","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Laurentiu","Am fost putin sceptic la inceput, dar produsul chiar arata bine live. Telefonul pare mai elegant si mai special."],
["Laura","Produsul e fix ca in poze."],
["Alexandra","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Sonia","Nu ma asteptam sa fie asa placuta in mana."],
["Razvan","Livrare rapida, produs bun."],
["Claudia","Dupa cateva zile de folosire, se vede ca e gandita pentru look minimalist."],
["Cristina","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Alexia","Nu ma asteptam, dar nu aluneca usor din mana."],
["Ariana","Telefonul ramane aproape la fel de subtire, asta imi place cel mai mult."],
["Flavius","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Stefan","Se aseaza foarte bine."],
["Stefania","Merita banii."],
["Nicu","Telefonul ramane aproape la fel de subtire, asta imi place cel mai mult. Recomand."],
["Mario","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Alina","Imi place mult ideea, e diferita fata de husele normale."],
["Camelia","Dupa cateva zile de folosire pot spune ca sunt multumit. Sta bine, arata bine si se simte placut in mana."],
["Rebeca","Imi place mult ideea, e diferita fata de husele normale. Chiar sunt multumit."],
["Silviu","Am primit comanda repede si produsul arata foarte bine."],
["Mara","Nu ma asteptam, dar nu aluneca usor din mana."],
["Mihaela","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp. Arata foarte bine pe negru."],
["Ayan","Livrare rapida, produs bun."],
["Ianis","Se potriveste foarte bine si nu misca deloc."],
["Vasile","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Camelia","Arata simplu, dar se vede ca are un vibe mai premium."],
["Anca","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Rares","Am folosit-o cateva zile si sunt foarte multumit de alegere."],
["Camelia","La inceput mi s-a parut ciudata ideea, dar dupa ce am vazut-o pe telefon am inteles de ce arata asa bine. Sunt multumit."],
["Maria","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Alexia","Merita banii."],
["Luca","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant. Recomand."],
["Paul","Nu ma asteptam sa fie asa placuta in mana."],
["Cristian","Ca aspect, e simpla, dar de efect."],
["Aris","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Claudiu","Sincer nu eram sigur daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut mult mai faina decat o husa normala."],
["Catalin","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."],
["Marius","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Octavian","Se monteaza usor si schimba complet aspectul telefonului."],
["Vasile","Se monteaza usor si schimba complet aspectul telefonului."],
["Silviu","Pe telefon arata nu aluneca usor din mana."],
["Nicoleta","Se simte calitativa. Chiar sunt multumit."],
["Marius","Arata premium."],
["Daria","Se simte calitativa. Mi-a placut mult."],
["Anca","Am primit multe intrebari despre ea, arata chiar interesant."],
["Flavia","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp."],
["Stefan","Arata simplu, dar se vede ca are un vibe mai premium."],
["Eduard","Am luat-o din curiozitate si sincer m-a surprins placut."],
["Paul","Foarte multumit, arata top. Recomand."],
["Mihnea","Foarte ok la prima impresie."],
["Vlad","Sunt foarte incantat."],
["Daria","Produsul e fix ca in poze."],
["Iulia","Super clean pe telefon. Arata foarte bine pe negru."],
["Delia","Am primit multe intrebari despre ea, arata chiar interesant."],
["Ioana","Am folosit-o cateva zile si sunt foarte multumit de alegere."],
["Mihaela","Sunt foarte incantat."],
["Tavi","Ca aspect, nu aluneca usor din mana."],
["Tudor","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Raluca","Am primit comanda repede si produsul arata foarte bine."],
["Irina","Mi-a placut si ambalajul, iar husa se simte calitativa. Nu pare un produs luat la intamplare, chiar arata premium."],
["Silviu","Ca aspect, a fost exact ce cautam."],
["Iulia","E fix genul de husa discreta pe care o cautam de mult."],
["Diana Maria","Recomand, chiar e misto."],
["Anca","Livrare rapida, produs bun."],
["Ariana","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata. Chiar sunt multumit."],
["Tavi","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat. Recomand."],
["Nicoleta","Telefonul ramane aproape la fel de subtire, asta imi place cel mai mult."],
["Silviu","Se simte calitativa."],
["Iulia","Imi place mult ideea, e diferita fata de husele normale."],
["David","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Paula","Se monteaza usor si schimba complet aspectul telefonului."],
["Larisa","Clean si usoara."],
["Carla","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna."],
["Sorina","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Denisa","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."],
["Florin","Nu ingroasa telefonul."],
["Ariana","Produsul e fix ca in poze."],
["Timeea","Nu ma asteptam, dar imi lasa telefonul sa arate ca telefon, nu ca o caramida."],
["Darius","Mi se pare foarte potrivita pentru cine vrea protectie discreta si un look mai premium. Eu sunt multumit de alegere."],
["Laurentiu","Arata simplu, dar se vede ca are un vibe mai premium."],
["Denis","Am fost putin sceptic la inceput, dar produsul chiar arata bine live. Telefonul pare mai elegant si mai special."],
["Valentina","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Gabriel","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant. Recomand."],
["Amalia","Am luat-o din curiozitate si sincer m-a surprins placut. Arata foarte bine pe negru."],
["Florin","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Madalina","Dupa cateva zile de folosire pot spune ca sunt multumit. Sta bine, arata bine si se simte placut in mana."],
["Claudia","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon. Mi-a placut mult."],
["Robert","Recomand, chiar e misto. Chiar sunt multumit."],
["Cosmin","Simpla si eleganta."],
["Dragos","Ca aspect, se vede ca e gandita pentru look minimalist."],
["Nicoleta","Super clean pe telefon."],
["Ionut","Nu ma asteptam sa fie asa placuta in mana."],
["Roxana","Imi place mult ideea, e diferita fata de husele normale."],
["Daria","Am comandat pentru iPhone si se potriveste perfect. Imi place ca ramane vizibil spatele telefonului si nu il acopera aiurea."],
["Aris","Livrare rapida, produs bun."],
["Catalin","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Calin","Mi se pare foarte potrivita pentru cine vrea protectie discreta si un look mai premium. Eu sunt multumit de alegere."],
["Diana","Se simte bine in mana si nu pare deloc ieftina."],
["Nicolas","Nu ma asteptam, dar se potriveste cu stilul meu."],
["Ana","Nu ma asteptam, dar imi lasa telefonul sa arate ca telefon, nu ca o caramida. Recomand."],
["Rares","Recomand, chiar e misto."],
["Teodora","Foarte multumit, arata top."],
["Carla","Arata premium."],
["Ioana","Produsul e fix ca in poze."],
["Ayan","Am primit multe intrebari despre ea, arata chiar interesant."],
["Giulia","Se potriveste foarte bine si nu misca deloc."],
["Adina","Nu ma asteptam, dar se potriveste cu stilul meu."],
["Georgiana","Am primit comanda repede si produsul arata foarte bine."],
["Amalia","E fix genul de husa discreta pe care o cautam de mult."],
["Maria","Imi place mult ideea, e diferita fata de husele normale."],
["Beatrice","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant. Chiar sunt multumit."],
["Alina","E fix genul de husa discreta pe care o cautam de mult."],
["Gabriela","Dupa cateva zile de folosire pot spune ca sunt multumit. Sta bine, arata bine si se simte placut in mana."],
["Iustin","Foarte ok la prima impresie."],
["Cosmin","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna. Arata foarte bine pe negru."],
["Monica","Imi place ca telefonul ramane subtire si arata in continuare premium."],
["Madalina","Cel mai mult imi place ca nu face telefonul gros. Recomand."],
["Eduard","Prima impresie: imi lasa telefonul sa arate ca telefon, nu ca o caramida."],
["Sorina","Produsul e fix ca in poze."],
["Mara","Am comandat-o pentru ca voiam ceva diferit, nu o husa mare si greoaie. Arata foarte bine si telefonul ramane clean."],
["Dragos","Livrare rapida, produs bun."],
["Sonia","Am primit multe intrebari despre ea, arata chiar interesant."],
["Patricia","Livrare rapida, produs bun."],
["Ariana","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Catalin","Am luat-o din curiozitate si sincer m-a surprins placut."],
["Lucian","Prima impresie: nu face telefonul gros."],
["Paul","Am luat-o din curiozitate si sincer m-a surprins placut."],
["Cosmin","La inceput mi s-a parut ciudata ideea, dar dupa ce am vazut-o pe telefon am inteles de ce arata asa bine. Sunt multumit."],
["Claudia","Se monteaza usor si schimba complet aspectul telefonului."],
["Mihaela","Am primit multe intrebari despre ea, arata chiar interesant. Mi-a placut mult."],
["Simona","Recomand, chiar e misto."],
["Paula","Mi se pare foarte potrivita pentru cine vrea protectie discreta si un look mai premium. Eu sunt multumit de alegere."],
["Beatrice","Prima impresie: mi se pare foarte clean."],
["Gabriela","Dupa cateva zile de folosire pot spune ca sunt multumit. Sta bine, arata bine si se simte placut in mana. Recomand."],
["Albert","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Paul","Nu ma asteptam sa fie asa placuta in mana."],
["Monica","Dupa cateva zile de folosire, mi se pare foarte clean."],
["Sebi","Culoarea arata bine si se potriveste perfect pe telefon."],
["Oana","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Ilinca","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Octavian","Imi place ca telefonul ramane subtire si arata in continuare premium."],
["Rares","Se monteaza usor si schimba complet aspectul telefonului."],
["George","Arata premium."],
["Albert","Foarte ok la prima impresie."],
["Flavius","E fix genul de husa discreta pe care o cautam de mult."],
["Cristina","Nu ingroasa telefonul. Arata foarte bine pe negru."],
["Patricia","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Tudor","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna."],
["Paula","E o alternativa foarte buna la husele clasice."],
["Georgiana","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Eduard","Am comandat-o pentru ca voiam ceva diferit, nu o husa mare si greoaie. Arata foarte bine si telefonul ramane clean. Recomand."],
["Madalina","Arata premium."],
["Stefania","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Raul","Super clean pe telefon."],
["George","Telefonul ramane aproape la fel de subtire, asta imi place cel mai mult."],
["Monica","Perfecta pentru iPhone."],
["Iulia","Imi place mult ideea, e diferita fata de husele normale. Chiar sunt multumit."],
["Vasile","Nu ma asteptam, dar nu aluneca usor din mana."],
["Sorina","Foarte multumit, arata top."],
["Valentina","Se potriveste foarte bine si nu misca deloc."],
["Laura","La inceput mi s-a parut ciudata ideea, dar dupa ce am vazut-o pe telefon am inteles de ce arata asa bine. Sunt multumit."],
["Anca","Arata premium."],
["Teodora","Imi place ca telefonul ramane subtire si arata in continuare premium."],
["Claudiu","Am folosit-o cateva zile si sunt foarte multumit de alegere."],
["Stefan","Am folosit-o cateva zile si sunt foarte multumit de alegere."],
["Ciprian","Am luat-o pentru ca se potriveste cu stilul meu."],
["Laura","Dupa cateva zile de folosire, a fost exact ce cautam."],
["Nicoleta","Imi place mult ideea, e diferita fata de husele normale. Recomand."],
["Sonia","Culoarea arata bine si se potriveste perfect pe telefon."],
["Rares","La inceput mi s-a parut ciudata ideea, dar dupa ce am vazut-o pe telefon am inteles de ce arata asa bine. Sunt multumit."],
["Denisa","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Andrei","Culoarea arata bine si se potriveste perfect pe telefon."],
["David","Mi-a placut si ambalajul, iar husa se simte calitativa. Nu pare un produs luat la intamplare, chiar arata premium. Mi-a placut mult."],
["Alexandra","Ca aspect, se potriveste cu stilul meu."],
["Alina","Livrare rapida, produs bun."],
["Eduard","Produsul e fix ca in poze."],
["Giulia","Am comandat-o ieri si se vede ca e gandita pentru look minimalist. Arata foarte bine pe negru."],
["Carmen","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp."],
["David","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Vasile","Produs bun, ambalaj ok si livrarea a fost rapida. Chiar sunt multumit."],
["Cristina","Imi place mult."],
["Carla","Mi-a placut si ambalajul, iar husa se simte calitativa. Nu pare un produs luat la intamplare, chiar arata premium."],
["Cezara","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."],
["Teodora","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna."],
["Darius","Imi place ca telefonul ramane subtire si arata in continuare premium. Recomand."],
["Dragos","E fix genul de husa discreta pe care o cautam de mult."],
["Teodora","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna."],
["Claudia","Am fost putin sceptic la inceput, dar produsul chiar arata bine live. Telefonul pare mai elegant si mai special."],
["Sebastian","Perfecta pentru iPhone."],
["Albert","Recomand, chiar e misto."],
["Silviu","Sincer nu eram sigur daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut mult mai faina decat o husa normala."],
["Alina","Am comandat pentru iPhone si se potriveste perfect. Imi place ca ramane vizibil spatele telefonului si nu il acopera aiurea."],
["Carmen","Perfecta pentru iPhone."],
["Raluca","Am comandat-o pentru ca voiam ceva diferit, nu o husa mare si greoaie. Arata foarte bine si telefonul ramane clean."],
["Daria","Sincer, imi lasa telefonul sa arate ca telefon, nu ca o caramida."],
["Ioana","Dupa cateva zile de folosire pot spune ca sunt multumit. Sta bine, arata bine si se simte placut in mana."],
["Gabriel","Nu ma asteptam, dar imi lasa telefonul sa arate ca telefon, nu ca o caramida."],
["Mihaela","E fix genul de husa discreta pe care o cautam de mult."],
["Calin","Am folosit-o cateva zile si sunt foarte multumit de alegere."],
["Carla","Am fost putin sceptic la inceput, dar produsul chiar arata bine live. Telefonul pare mai elegant si mai special."],
["Fabian","Se aseaza foarte bine."],
["Paul","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam. Recomand."],
["Adrian","Se potriveste foarte bine si nu misca deloc. Chiar sunt multumit."],
["Simona","Mi-a placut si ambalajul, iar husa se simte calitativa. Nu pare un produs luat la intamplare, chiar arata premium."],
["Isabela","Produsul e fix ca in poze."],
["Loredana","Sunt foarte incantat."],
["Claudiu","Imi place mult ideea, e diferita fata de husele normale."],
["Isabela","Am primit comanda repede si produsul arata foarte bine. Arata foarte bine pe negru."],
["Valentina","E fix genul de husa discreta pe care o cautam de mult."],
["Sabina","Nu ma asteptam sa fie asa placuta in mana."],
["Edi","Merita banii."],
["Simona","Am primit comanda repede si produsul arata foarte bine."],
["Cosmin","La inceput mi s-a parut ciudata ideea, dar dupa ce am vazut-o pe telefon am inteles de ce arata asa bine. Sunt multumit."],
["Stefan","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Luca","Dupa cateva zile de folosire pot spune ca sunt multumit. Sta bine, arata bine si se simte placut in mana."],
["Stefania","Se aseaza foarte bine. Mi-a placut mult."],
["Marius","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Ema","Am luat-o din curiozitate si sincer m-a surprins placut."],
["Flavius","Imi place ca telefonul ramane subtire si arata in continuare premium. Recomand."],
["Lavinia","Pentru cine vrea sa isi pastreze telefonul cat mai aproape de forma lui originala, mi se pare o varianta foarte buna."],
["Oana","Exact ce voiam."],
["Loredana","Imi place mult."],
["Laura","Arata simplu, dar se vede ca are un vibe mai premium."],
["Teodora","Nu ma asteptam sa fie asa placuta in mana."],
["Mihnea","Am primit comanda repede si produsul arata foarte bine."],
["Matei","Foarte multumit, arata top. Chiar sunt multumit."],
["Tudor","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Natalia","E o alternativa foarte buna la husele clasice."],
["Sorin","Livrare rapida, produs bun."],
["Adelina","Se simte bine in mana si nu pare deloc ieftina."],
["Alexandra","Foarte multumit, arata top."],
["Mihaela","Livrare rapida, produs bun."],
["Loredana","Simpla si eleganta."],
["Matei","Foarte faina husa."],
["Georgiana","Se simte calitativa."],
["Cosmin","Dupa cateva zile de folosire pot spune ca sunt multumit. Sta bine, arata bine si se simte placut in mana. Recomand."],
["Cristina","Exact ce voiam."],
["Monica","Ca aspect, pare mult mai scumpa decat ma asteptam."],
["Victor","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp. Arata foarte bine pe negru."],
["Teodora","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Antonio","Am comandat-o ieri si nu face telefonul gros."],
["Roxana","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Adrian","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Anca","Mi-a placut si ambalajul, iar husa se simte calitativa. Nu pare un produs luat la intamplare, chiar arata premium."],
["Ilinca","Mi se pare foarte potrivita pentru cine vrea protectie discreta si un look mai premium. Eu sunt multumit de alegere."],
["Nicolas","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."],
["Aris","Sincer, nu face telefonul gros."],
["Matei","Foarte ok la prima impresie."],
["Simona","Exact ce voiam. Chiar sunt multumit."],
["Valentina","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."],
["Nicoleta","Pe telefon arata pare mult mai scumpa decat ma asteptam."],
["Rebeca","Arata premium."],
["Stefan","Arata foarte clean si nu ascunde deloc designul telefonului. Recomand."],
["Alexandra","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp."],
["Nicolas","Foarte multumit, arata top."],
["Andreea","Perfecta pentru iPhone."],
["Iulia","Arata mai bine live."],
["Ana","Perfecta pentru iPhone."],
["Stefan","Dupa cateva zile de folosire pot spune ca sunt multumit. Sta bine, arata bine si se simte placut in mana. Mi-a placut mult."],
["Sorin","Imi place mult ideea, e diferita fata de husele normale."],
["Albert","Se simte bine in mana si nu pare deloc ieftina."],
["Flavia","Am folosit-o cateva zile si sunt foarte multumit de alegere."],
["Matei","Cel mai mult imi place ca mi se pare foarte clean."],
["Paula","Am luat-o din curiozitate si sincer m-a surprins placut."],
["Paul","Produsul e fix ca in poze."],
["Antonio","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Catalin","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna."],
["Cristian","E o alternativa foarte buna la husele clasice."],
["Dragos","Nu ma asteptam, dar nu aluneca usor din mana."],
["Mario","Nu ma asteptam sa fie asa placuta in mana. Recomand."],
["Octavian","Produsul e fix ca in poze."],
["Monica","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat. Chiar sunt multumit."],
["Florin","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Mihaela","Minimalista si frumoasa."],
["Paul","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp."],
["Adrian","La inceput mi s-a parut ciudata ideea, dar dupa ce am vazut-o pe telefon am inteles de ce arata asa bine. Sunt multumit."],
["Ioana","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Denis","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Adelina","Arata premium."],
["Mihnea","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp."],
["Alexandru","Sincer nu eram sigur daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut mult mai faina decat o husa normala."],
["Victor","Am primit multe intrebari despre ea, arata chiar interesant."],
["Lucian","Se monteaza usor si schimba complet aspectul telefonului."],
["Cristian","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Fabian","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."],
["Mihnea","Foarte multumit, arata top."],
["Victor","Clean si usoara. Recomand."],
["Vasile","Se simte bine in mana si nu pare deloc ieftina."],
["Loredana","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Patricia","Am primit comanda repede si produsul arata foarte bine."],
["Denisa","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Laura","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Cristina","Minimalista si frumoasa."],
["Ariana","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Catalin","Arata simplu, dar se vede ca are un vibe mai premium. Chiar sunt multumit."],
["Rares","Minimalista si frumoasa."],
["Florin","Cel mai mult imi place ca pare mult mai scumpa decat ma asteptam."],
["Sonia","Minimalista si frumoasa."],
["Lavinia","Culoarea arata bine si se potriveste perfect pe telefon."],
["Patrick","Nu e genul clasic de husa si fix asta imi place la ea. Se vede diferit, dar intr-un mod bun si elegant."],
["Diana","Arata mai bine live. Arata foarte bine pe negru."],
["Alexandra","Foarte faina husa. Mi-a placut mult."],
["Ioana","Se aseaza foarte bine."],
["Claudia","Arata premium. Recomand."],
["Larisa","Se simte bine in mana si nu pare deloc ieftina."],
["Iulia","Clean si usoara."],
["Antonio","Telefonul ramane aproape la fel de subtire, asta imi place cel mai mult."],
["Alexandru","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Paula","Imi place mult."],
["Sorin","Nu ingroasa telefonul."],
["Valentin","Am primit comanda repede si produsul arata foarte bine."],
["Alexia","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Stefan","La inceput mi s-a parut ciudata ideea, dar dupa ce am vazut-o pe telefon am inteles de ce arata asa bine. Sunt multumit."],
["Robert","Dupa cateva zile de folosire, a fost exact ce cautam."],
["Rares","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Raluca","Super clean pe telefon."],
["Ema","Se potriveste foarte bine si nu misca deloc."],
["Madalina","Nu suport husele groase, iar asta mi se pare varianta perfecta. Chiar sunt multumit."],
["Edi","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["David","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Lucian","Dupa cateva zile de folosire, nu face telefonul gros. Recomand."],
["Alexandru","Se potriveste foarte bine si nu misca deloc."],
["Tudor","Merita banii."],
["Laura","Nu imi plac husele care fac telefonul mare si greu. Asta e usoara, discreta si arata foarte bine pe telefon."],
["Darius","Foarte ok la prima impresie."],
["Florin","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Anca","Am comandat-o pentru ca voiam ceva diferit, nu o husa mare si greoaie. Arata foarte bine si telefonul ramane clean."],
["David","Am comandat-o ieri si se potriveste cu stilul meu."],
["Mara","Arata premium."],
["Octavian","Foarte faina husa."],
["Delia","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Darius","Daca vrei ceva minimalist, chiar e ce trebuie. Arata foarte bine pe negru."],
["Simona","Se potriveste foarte bine si nu misca deloc."],
["Georgiana","Sincer nu eram sigur daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut mult mai faina decat o husa normala."],
["Ionut","Pentru mine, se potriveste cu stilul meu."],
["Iulia","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp."],
["Eduard","Nu suport husele groase, iar asta mi se pare varianta perfecta."],
["Andrei","Imi place ca telefonul ramane subtire si arata in continuare premium. Recomand."],
["Marius","Daca vrei ceva minimalist, chiar e ce trebuie."],
["Octavian","E o alternativa foarte buna la husele clasice."],
["Flavia","Arata premium. Chiar sunt multumit."],
["Amalia","Pentru mine, arata foarte bine in poze si live."],
["Robert","Nu ma asteptam, dar se potriveste cu stilul meu."],
["Valentin","La inceput mi s-a parut ciudata ideea, dar dupa ce am vazut-o pe telefon am inteles de ce arata asa bine. Sunt multumit."],
["Roxana","E fix genul de husa discreta pe care o cautam de mult. Mi-a placut mult."],
["Florin","Dupa cateva zile de folosire, arata foarte bine in poze si live."],
["Luca","Am comandat pentru iPhone si se potriveste perfect. Imi place ca ramane vizibil spatele telefonului si nu il acopera aiurea."],
["Darius","Dupa cateva zile de folosire, se potriveste cu stilul meu."],
["Andreea","Prima impresie: pare mult mai scumpa decat ma asteptam."],
["George","Ca aspect, se vede ca e gandita pentru look minimalist."],
["Alexandru","Arata foarte clean si nu ascunde deloc designul telefonului."],
["Bogdan","Am comandat pentru iPhone si se potriveste perfect. Imi place ca ramane vizibil spatele telefonului si nu il acopera aiurea."],
["Valentin","Sincer nu eram sigur daca o sa imi placa, dar dupa ce am pus-o pe telefon mi s-a parut mult mai faina decat o husa normala."],
["George","Recomand, chiar e misto."],
["Eric","Imi place mult ca pastreaza designul telefonului si totusi ii da un aspect mai premium. Pentru mine chiar a fost o alegere buna. Recomand."],
["Cosmin","Produsul e fix ca in poze."],
["Silviu","Mi se pare foarte potrivita pentru cine vrea protectie discreta si un look mai premium. Eu sunt multumit de alegere."],
["Andreea","Simpla si eleganta."],
["Cezara","Se simte bine in mana si nu pare deloc ieftina."],
["Flavius","Livrare rapida, produs bun."],
["Timeea","E fix genul de husa discreta pe care o cautam de mult."],
["Cezara","Produs bun, ambalaj ok si livrarea a fost rapida."],
["Natalia","O folosesc zilnic si imi place ca nu simt telefonul mai mare in buzunar. E exact ce cautam de ceva timp. Arata foarte bine pe negru."],
["Mara","Am primit multe intrebari despre ea, arata chiar interesant. Chiar sunt multumit."],
["Alexia","E o alternativa foarte buna la husele clasice."],
["Miruna","E o alternativa foarte buna la husele clasice."],
["Nicoleta","Telefonul ramane aproape la fel de subtire, asta imi place cel mai mult."],
["Ilinca","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."],
["Miruna","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Larisa","Comanda a ajuns ok, produsul a fost ambalat bine si dupa montaj telefonul arata mult mai clean decat ma asteptam."],
["Iustin","Arata premium."],
["Vasile","Simpla si eleganta. Recomand."],
["Nicu","Telefonul arata mult mai elegant cu ea, fara sa fie incarcat."],
["Simona","Am comandat-o pentru ca voiam ceva diferit, nu o husa mare si greoaie. Arata foarte bine si telefonul ramane clean."],
["Alex","Am primit multe intrebari despre ea, arata chiar interesant."],
["Madalina","Pentru mine, mi se pare foarte clean."],
["Denisa","Se simte bine in mana si nu pare deloc ieftina."],
["Tavi","Am avut multe huse pana acum, dar asta e prima care nu imi strica designul telefonului. Chiar imi place cum arata."]
  ];

  function initials(name){
    return name.trim().split(/\s+/).slice(0,2).map(function(p){ return p.charAt(0); }).join('').toUpperCase();
  }

  // A realistic-looking spread instead of every single card showing 5 stars.
  // Based on a hash of the review's own name+text, so it's the same every time
  // you load the page (not reshuffled on refresh) and has nothing to do with
  // position in the list. Nothing about the text itself is ever touched.
  function starsFor(name, text){
    var str = name + '|' + text, h = 0;
    for (var i = 0; i < str.length; i++){ h = (h * 31 + str.charCodeAt(i)) >>> 0; }
    var bucket = h % 100;
    if (bucket < 72) return 5;
    if (bucket < 93) return 4;
    return 3;
  }
  function starsHtml(count){
    var filled = '★'.repeat(count);
    var empty = count < 5 ? '<span style="opacity:.3">' + '★'.repeat(5 - count) + '</span>' : '';
    return filled + empty;
  }

  var grid = document.getElementById('reviews-modal-grid');
  if (!grid) return;

  var frag = document.createDocumentFragment();

  photoReviews.forEach(function(r){
    var card = document.createElement('div');
    card.className = 'rv-card';
    card.innerHTML =
      '<div class="rv-top">' +
        '<img class="rv-avatar" src="' + r.url + '" width="56" height="56" alt="' + r.name + '" loading="lazy">' +
        '<div class="rv-meta">' +
          '<span class="rv-name">' + r.name + '</span>' +
          '<span class="rv-stars">' + starsHtml(starsFor(r.name, r.text)) + '</span>' +
          '<span class="rv-verified">✔ Cumpărător verificat</span>' +
        '</div>' +
      '</div>' +
      '<p class="rv-text"></p>';
    card.querySelector('.rv-text').textContent = r.text;
    frag.appendChild(card);
  });

  textReviews.forEach(function(r){
    var name = r[0], text = r[1];
    var card = document.createElement('div');
    card.className = 'rv-card';
    card.innerHTML =
      '<div class="rv-top">' +
        '<span class="rv-avatar-initial"></span>' +
        '<div class="rv-meta">' +
          '<span class="rv-name"></span>' +
          '<span class="rv-stars">' + starsHtml(starsFor(name, text)) + '</span>' +
          '<span class="rv-verified">✔ Cumpărător verificat</span>' +
        '</div>' +
      '</div>' +
      '<p class="rv-text"></p>';
    card.querySelector('.rv-avatar-initial').textContent = initials(name);
    card.querySelector('.rv-name').textContent = name;
    card.querySelector('.rv-text').textContent = text;
    frag.appendChild(card);
  });

  grid.appendChild(frag);

  var countEl = document.getElementById('reviews-count');
  if (countEl) countEl.textContent = photoReviews.length + textReviews.length;
})();
